import React, { useContext, useEffect, useMemo, useState } from 'react';
import "../scss/solutionsStudio.scss";
import "../../document_ai/scss/DocumentAIPage.scss";
import ibexDarkFullIcon from "../../../images/darkLeftBarIcons/ibexDarkFullIcon.png";
import ibexLightFullIcon from "../../../images/lightLeftBarIcons/ibexLightFullIcon.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowRight, faCheck, faChevronLeft, faFileInvoice, faFileLines, faPlus, faUpload, faXmark } from '@fortawesome/free-solid-svg-icons';
import FileUploadContainers from '../../../components/shared/FileUploadContainers';
import { APIS_LIST, DOC_AI_MODE_ENUM, IConversationModel, IExtractesDataModel, ITemplateAttributesModel, KB_NAMES_ENUM, PROCESSING_TABS, SOLUTION_STUDIO_TABS } from '../../../models/ChatModels';
import FileViewer from '../../../commonfields/FileViewer';
import { Alert, Button, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import ChatComponent2 from '../../../components/chat/ChatComponent2';
import { v4 as uuid } from "uuid";

import home from "../../../images/darkLeftBarIcons/home.png";
import documentText from "../../../images/darkLeftBarIcons/document-text.png";
import copy from "../../../images/darkLeftBarIcons/copy.png";
import checkmarkCicle from "../../../images/darkLeftBarIcons/checkmark-circle.png";
import listCicle from "../../../images/darkLeftBarIcons/list-circle.png";
import chatIcon from "../../../images/darkLeftBarIcons/chatbox.png";
import configIcon from "../../../images/darkLeftBarIcons/config.png";

import helpCicle from "../../../images/darkLeftBarIcons/help-circle.png";
import settings from "../../../images/darkLeftBarIcons/settings.png";
import logOut from "../../../images/darkLeftBarIcons/log-out.png";

import homeLight from "../../../images/lightLeftBarIcons/home.png";
import documentTextLight from "../../../images/lightLeftBarIcons/document-text.png";
import copyLight from "../../../images/lightLeftBarIcons/copy.png";
import checkmarkCicleLight from "../../../images/lightLeftBarIcons/checkmark-circle.png";
import listCicleLight from "../../../images/lightLeftBarIcons/list-circle.png";
import chatIconLight from "../../../images/lightLeftBarIcons/chatbox.png";
import configIconLight from "../../../images/lightLeftBarIcons/config.png";

import homeChecked from "../../../images/CheckedIcons/home.png";
import documentTextChecked from "../../../images/CheckedIcons/document-text.png";
import copyChecked from "../../../images/CheckedIcons/copy.png";
import checkmarkCicleChecked from "../../../images/CheckedIcons/checkmark-circle.png";
import listCicleChecked from "../../../images/CheckedIcons/list-circle.png";
import chatIconChecked from "../../../images/CheckedIcons/chatbox.png";
import configIconChecked from "../../../images/CheckedIcons/config.png";


import helpCicleLight from "../../../images/lightLeftBarIcons/help-circle.png";
import settingsLight from "../../../images/lightLeftBarIcons/settings.png";
import logOutLight from "../../../images/lightLeftBarIcons/log-out.png";

import uploadInformation from "../../../images/UploadInformation.png";
import { RoutesEnum } from '../../../models/RoutesModel';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  setToSession,
  getFromSession,
  removeFromSession,
} from "../../../helpers/GenericHelpers";
import { ProjectStatus } from '../../../models/ProjectModel';
import documentAIService from '../../document_ai/documentAIService';
import { IDocUserQueryInput, IIngestKdbInput, IKDBProjectInput, IKeyInfoInput } from '../../../models/APIModels';
import { LOADER_ENUM, LOADER_OPTIONS } from '../../../models/LoaderModel';
import { ILogsModel } from '../../../models/LogsModel';
import { IAPIPromptsModel, ProjectTypeEnum, ThemeTypes } from '../../../models/SharedModel';
import { pushToLog } from '../../../helpers/LogHelpers';
import { toast } from 'react-toastify';
import { MainContext } from '../../../models/MainContext';
import TemplateAttributes from '../../../components/chat/TemplateAttributes';
import LoaderHOC from '../../../components/shared/LoaderHOC';
import ExtractedData from '../../../components/chat/ExtractedData';
import NewProjectModal from '../../../components/project/NewProjectModal';
import LogsModal from '../../../components/shared/LogsModal';
import ApiModal from '../../../components/shared/ApiModal';
import Settings from '../../../components/shared/Settings';
import GlobalLoader from '../../../commonfields/GlobalLoader';
import Profile from '../../../components/shared/Profile';
import { ThemeContext } from '../../../models/ThemeContext';
import FileItem from '../../../components/shared/FileItem';
import RawPdfViewer from '../../../commonfields/RawPdfViewer';
import QueiryForm from '../../../components/shared/QueiryForm';
import { TemplateAttributesCSV, jsonToCsv } from '../../../helpers/TemplateAttributesCSV';
import OutputForm from '../../../components/shared/OutputForm';
// import poweredByLogo from "../../../images/PoweredByLogo.SVG";
import DeleteIcon from "../../../images/delete-icon.svg";

type Props = {}

const Solutionstudio = (props: Props) => {
  const service = new documentAIService();
  const { themeName } = useContext(ThemeContext);

  const images:string[]=
   (themeName === ThemeTypes.DARK_THEME) ?
    [home, documentText, checkmarkCicle, listCicle, copy, chatIcon, helpCicle, settings, logOut, configIcon]
   : [homeLight, documentTextLight, checkmarkCicleLight, listCicleLight, copyLight, chatIconLight, helpCicleLight, settingsLight, logOutLight, configIconLight]

  const checked = [homeChecked, documentTextChecked, checkmarkCicleChecked, listCicleChecked, copyChecked, chatIconChecked, configIconChecked];
  const { projectName, version } = useParams();
  const location = useLocation();
  const projectType = useMemo(
    () => location?.pathname?.split("/")?.[2],
    [location?.pathname]
  );

  const [documentFile, setDocumentFile] = useState<any>();
  const [attributes, setAttributes] = useState<ITemplateAttributesModel[]>([]);
  const [attrModal, setAttrModal] = useState(false);

  const [settingsModal, setSettingsModal] = useState(false);

  const [loader, setLoader] = useState(false);
  const [isDockUploaded, setIsDockUploaded] = useState(false);
  const [conversationList, setConversationList] = useState<IConversationModel[]
  >([]);
  const [mode, setMode] = useState(DOC_AI_MODE_ENUM.SINGLE_DOCUMENT_MODE); // document ai modes
  const [processingTabs, setProcessingTabs] = useState(
    SOLUTION_STUDIO_TABS.DOCUMENT
  );

  const [processingTabs2, setProcessingTabs2] = useState(
    PROCESSING_TABS.DOCUMENT
  );
  const [promtStatus, setPromtStatus] = useState<any>([]);
  const [questionsList, setQuestionsList] = useState([]);
  const [autoTemplate, setAutoTemplate] = useState<any>();
  const [initAttributes, setInitAttributes] = useState<
    ITemplateAttributesModel[]
  >([]);
  const [logsModal, setLogsModal] = useState(false); // modal to get logs
  const [summarizationPrompt, setSummarizationPrompt] = useState("");
  const [validationPrompt, setValidationPrompt] = useState("");
  const [extractedData, setExtractedData] = useState<IExtractesDataModel[]>([]);
  const [dontScroll, setDontScroll] = useState(false);
  const [unique_kdbState, setUnique_kdbState] = useState('');
  const [docType, setDocType] = useState("");
  const [docSummary, setDocSummary] = useState("");
  const [chatLoader, setChatLoader] = useState(false);
  const [tempAttr, setTempAttr] = useState<ITemplateAttributesModel | null>(
    null
  );
  const [apiModal, setAPIModal] = useState(false);
  const [newModal, setNewModal] = useState(false); // modal to create new project
  const userName = getFromSession('user_name');

  const { modifyLoaders } = useContext(MainContext);

  const toggleAttrModal = () => setAttrModal((prev) => !prev);

  const toggleSettingsModal = () => setSettingsModal((prev) => !prev);

  const toggleLogsModal = () => setLogsModal((prev) => !prev);

  const toggleNewModal = () => setNewModal((prev) => !prev);

  const handleAPIListSuccess = (values: any) => {
    save_prompts(values);
    toggleAPIModal();
  };

  const logout = () => {
    removeFromSession('user_name')
    removeFromSession('user_id')
    navigate(`/${RoutesEnum.LOGIN}`)
  }

  const save_prompts = (data: any) => {
    setLoader(true);
    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
    const payload = {
      project_name: projectName,
      project_type: projectType,
      kdbName,
      version,
      project_id: project_main?.project_id,
    };

    service
      .save_prompts(payload as IKDBProjectInput, data)
      .then((res) => {
        toggleAPIModal();
        toast.success(res?.data);
        navigate(`${RoutesEnum.LANDING}/${ProjectStatus.PRODUCTION}`);
        setLoader(false);
        const logData: ILogsModel = {
          log_id: uuid(),
          project_id: project_main?.project_id,
          username: user_id,
          solution: projectName || "",
          solution_type: projectType as ProjectTypeEnum,
          api: "/save_prompts",
          prompt: "",
          result: res?.data,
          tags: [],
          violations: [],
          role: "USER",
          time: new Date(),
        };
        pushToLog(logData);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  const promptsList = useMemo<IAPIPromptsModel[]>(
    () =>
      conversationList
        ?.filter((each) => each?.prompt?.apiCheck)
        ?.map((each2) => ({
          prompt: each2?.prompt?.value,
          status: false,
          type: APIS_LIST.CHATBOT,
        })),
    [conversationList]
  );

  const apiSuccessCallback = () => navigate(`/${RoutesEnum.LANDING}`);


  const handleAPIListCancel = (values: any) => {
    toggleAPIModal();
  };

  const apisList = useMemo<IAPIPromptsModel[]>(
    () => [
      { type: APIS_LIST.VALIDATION, prompt: validationPrompt, status: false },
      {
        type: APIS_LIST.SUMMARIZATION,
        prompt: summarizationPrompt,
        status: false,
      },
      { type: APIS_LIST.DATA_EXTRACTION, prompt: "default", status: false },
    ],
    [validationPrompt, summarizationPrompt]
  );

  const resetAttributes = () => {
    setAttributes(initAttributes || []);
    setTempAttr(null);
  };

  const toggleAPIModal = () => {
    if (!apiModal) {
      save_chat_history(false, 'save_chat_hist')
    }
    setAPIModal((prev) => !prev)
  };

  const clearFields = () => {
    setDocumentFile(null);
    resetFields();
    removeFromSession(KB_NAMES_ENUM.KDB_NAME);
  };

  const resetFields = () => {
    setExtractedData([]);
    setQuestionsList([]);
    setConversationList([]);
    setDocSummary("");
    setInitAttributes([]);
    setAttributes([]);
    setDocType("");
    setDontScroll(false);
    setSummarizationPrompt('');
    setValidationPrompt('');
  };

  const submit_attributes = () => {
    if (attributes && attributes?.length > 0) {
      const unique_kdb = getFromSession(KB_NAMES_ENUM.KDB_NAME)
      const payload = {
        project_name: projectName,
        project_type: projectType,
        unique_kdb,
        version,
        project_id: project_main?.project_id,
      };
      const newAttributes = attributes?.map((each) => ({
        id: each?.id,
        description: each?.description,
        examples:
          each?.examples && each?.examples?.length > 0
            ? each?.examples?.map((each2: any) => {
              if (typeof each2 === "number") {
                return each2?.toString();
              } else if (typeof each2 === "string") {
                return each2;
              } else if (typeof each2 === "object") {
                return "";
              } else return "";
            })
            : ["none"],
      }));
      service
        .docai_process_template(payload as IKDBProjectInput, {
          attributes: newAttributes,
          id: autoTemplate?.id,
          description: autoTemplate?.description,
        })
        .then((res) => {
          // res?.data?.message && toast.success(res?.data?.message);
          const template = res?.data?.template;
          if (template) {
            docai_draft_keyinfo_ext(unique_kdb, template);
            toggleAttrModal();
          }
        })
        .catch((err) => console.log(err));
    }
  };


  const modifiedData = (values: any) => {
    const keys = Object.keys(values);
    return keys?.map((each) => ({
      dataId: uuid(),
      label: each,
      value: values?.[each],
      flags: [],
      roles: [],
      monitor: false,
      workflows: [],
    }));
  };
  const user_id = getFromSession("user_id");

  const navigate = useNavigate();

  const project_main = useMemo(() => {
    const project_main_raw = getFromSession("project_main");
    if (project_main_raw) return JSON.parse(project_main_raw);
    else return "";
  }, []);


  // display functions
  const displayLogsModal = useMemo(
    () => <LogsModal logsModal={logsModal} toggleLogsModal={toggleLogsModal} />,
    [logsModal]
  );
  const [chatInitiate, setChatInitiate] = useState(false);
  useEffect(() => {
    if (chatInitiate) {
      save_chat_history(true, 'save_chat_hist');
    }
  }, [chatInitiate && conversationList])

  useEffect(() => {
    console.log('call test')
    console.log([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus))
    console.log(!isDockUploaded)
    if ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && documentFile && !isDockUploaded) {
      ingest_doc_db();
      // auto_template()
    }
    else if ((project_main?.project_status === ProjectStatus.PRODUCTION) && documentFile) {
      ingest_doc_db();
    }
  }, [documentFile?.length > 0])

  const validationEnabled = useMemo(() => {
    if ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus)) {
      return true
    } else {
      // console.log(promtStatus?.find((each: any) => each?.[APIS_LIST.VALIDATION])?.status)
      const validation = promtStatus?.find((each: any) => each?.[APIS_LIST.VALIDATION])
      if (validation?.status) setValidationPrompt(validation?.[APIS_LIST.VALIDATION])
      return validation?.status
    }
  }, [project_main?.project_status, promtStatus])

  const summaryEnabled = useMemo(() => {
    if ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus)) {
      return true
    } else {
      // console.log(promtStatus?.find((each: any) => each?.[APIS_LIST.SUMMARIZATION])?.status)
      const summary = promtStatus?.find((each: any) => each?.[APIS_LIST.SUMMARIZATION])
      if (summary?.status) setSummarizationPrompt(summary?.[APIS_LIST.SUMMARIZATION])
      return summary?.status
    }
  }, [project_main?.project_status, promtStatus])

  const [fileType, setFileType] = useState();
  const handleDocumentChange = (e: any) => {
    setFileType(e[0]?.type)
    const name = `${KB_NAMES_ENUM.KDB_NAME}_${Math.floor(
      100000 + Math.random() * 900000
    )}`;
    setToSession(KB_NAMES_ENUM.KDB_NAME, name);
    setDocumentFile(e);
    if (e?.length === 0) {
      clearFields();
      setIsDockUploaded(false);
    }
    else {
      if (project_main?.project_status === ProjectStatus.PRODUCTION) {
        api_status_list()
      }
    }
  };

  const api_status_list = () => {
    setLoader(true);
    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
    const payload = {
      version,
      project_id: project_main?.project_id,
    };

    service
      .api_status_list(payload as IKDBProjectInput, ProjectStatus.PRODUCTION)
      .then((res) => {
        res?.data?.promt_status.push({
          "status": true,
          "docai_upload_file": "docai_upload_file'"
        })
        setPromtStatus(res?.data?.promt_status);
        const chatbot_prompts = res?.data?.promt_status?.find((each: any) => Object.keys(each)?.includes('chatbot_prompts'))?.chatbot_prompts
        setQuestionsList(chatbot_prompts?.filter((each: any) => each?.status));
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  // useEffects
  useEffect(() => {
    setLoader(true);
    if (project_main?.project_status === ProjectStatus.PRODUCTION) {
      api_status_list();
      // get_saved_project_info()
    } else {
      if (project_main?.project_id && project_main?.project_id?.length > 0) {
        setTimeout(() => {
          get_saved_project_info()
        }, 3000)
      }
    }
  }, [project_main?.project_status]);

  const save_chat_history = (loader = true, command:string) => {
    setChatInitiate(false)
    loader && setLoader(true);
    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
    const payload = {
      project_name: projectName,
      project_type: projectType,
      kdbName,
      version,
      project_id: project_main?.project_id,
      chat_history_op:command
    };
    service
      .save_chat_history(payload as IKDBProjectInput, conversationList)
      .then((res) => {
        if(command === 'clear_chat_history'){
          setConversationList([])
        }
        if (loader) {
          // toast.success(res?.data?.message)
          setLoader(false);
        }
      })
      .catch((err) => {
        console.log(err);
        loader && setLoader(false);
      });
  }

  const get_saved_project_info = () => {
    setLoader(true);
    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
    const payload = {
      project_id: project_main?.project_id,
    };
    service.get_saved_project_info(payload as IKDBProjectInput)
      .then((res) => {
        setToSession(KB_NAMES_ENUM.KDB_NAME, res?.data?.kdb_name)
        if ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus)) {
          // setDocumentFile([{
          //   ...res?.data?.document,
          //   name: res?.data?.document?.path,
          //   type: res?.data?.document?.path?.split('.')?.[1]
          // }])
          if (res?.data?.file_details?.extracted_info?.file_bytes && res?.data?.file_details?.extracted_info?.file_name) {
            top_querys_recommender();
            setIsDockUploaded(true)
            setDocumentFile([{
              ...res?.data?.file_details?.extracted_info?.file_bytes,
              value: res?.data?.file_details?.extracted_info?.file_bytes,
              name: res?.data?.file_details?.extracted_info?.file_name,
              path: res?.data?.file_details?.extracted_info?.file_name,
              type: res?.data?.file_details?.extracted_info?.file_name?.split('.')?.[1]
            }])
          }
        }
        if ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus)) {
          if (res?.data?.chat_history !== null) {
            setConversationList(res?.data?.chat_history)
          } else {
            const id = uuid();
            setConversationList([
              {
                id,
                prompt: { value: "Hi", time: new Date() },
                answer: {
                  value: "Hello! How may I assist you ?",
                  time: new Date(),
                },
              },
            ])
          }
        }
        const attrData = res?.data?.modified_json?.attributes
        const attr = attrData?.map(
          (each: ITemplateAttributesModel) => ({
            ...each,
            attributeId: uuid(),
            examples: each?.examples?.map((each2: any) => {
              if (typeof each2 === "object") {
                return each2?.[0];
              } else return each2;
            }),
          })
        );
        setAutoTemplate(res?.data?.modified_json);
        if(attr){
          setAttributes(attr);
          setInitAttributes(attr);
        }
        setLoader(false);
        setSummarizationPrompt(res?.data?.summarization_prompt)
        setValidationPrompt(res?.data?.validation_prompt);
        // Setting Extracted info
        if (res?.data?.extracted_info && res?.data?.extracted_info !== null) {
          let template = Object.keys(res?.data?.extracted_info)[0];
          const new_data = [ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && template ?
            modifiedData(res?.data?.extracted_info[template]) : res?.data?.extracted_info?.map((each: any) => ({ ...each, dataId: uuid() }));
          setExtractedData(new_data)
        }
        console.log('Response status test')
        console.log(res?.status)
      })
      .catch((err) => {
        setIsDockUploaded(false)
        console.log('Response Error test')
        console.log(err);
        setLoader(false);
      });
  }

  const auto_template = (loader = true) => {
    if (documentFile?.length > 0) {
      modifyLoaders(LOADER_ENUM.ADD_TEMPLATE, LOADER_OPTIONS.ADD);
      const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
      const payload = {
        file_name: (project_main?.project_status === ProjectStatus.PRODUCTION || ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded)) ? documentFile[0]?.path : undefined,
        files: ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded) ? undefined : documentFile,
        project_name: projectName,
        project_type: projectType,
        kdbName,
        version,
        project_id: project_main?.project_id,
        reload: ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded) ? "True" : "False",
      };
      service
        .docai_auto_template(payload as IIngestKdbInput)
        .then((res) => {
          if (res?.data?.attributes) {
            const attr = res?.data?.attributes?.map(
              (each: ITemplateAttributesModel) => ({
                ...each,
                attributeId: uuid(),
                examples: each?.examples?.map((each2: any) => {
                  if (typeof each2 === "object") {
                    return each2?.[0];
                  } else return each2;
                }),
              })
            );
            setAutoTemplate(res?.data);
            setAttributes(attr);
            setInitAttributes(attr);
            // toggleAttrModal();
            loader &&
              modifyLoaders(LOADER_ENUM.ADD_TEMPLATE, LOADER_OPTIONS.REMOVE);
            const logData: ILogsModel = {
              log_id: uuid(),
              project_id: project_main?.project_id,
              username: user_id,
              solution: projectName || "",
              solution_type: projectType as ProjectTypeEnum,
              api: "/docai_auto_template",
              prompt: "",
              result: JSON.stringify(res?.data),
              tags: [],
              violations: [],
              role: "USER",
              time: new Date(),
            };
            pushToLog(logData);
          }
        })
        .catch((err) => {
          if (err?.response?.data?.error) {
            toast.error(err?.response?.data?.error);
          } else console.log(err);
          loader &&
            modifyLoaders(LOADER_ENUM.ADD_TEMPLATE, LOADER_OPTIONS.REMOVE);
        });
    }
  };

  const ingest_doc_db = async () => {
    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
    const payload = {
      // files: documentFile,
      files: ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded) ? undefined : documentFile,
      file_name: (project_main?.project_status === ProjectStatus.PRODUCTION || ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded)) ? documentFile[0]?.path : undefined,
      project_name: projectName,
      reload: ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded) ? "True" : "False",
      project_type: projectType,
      kdbName,
      version,
      project_id: project_main?.project_id,
    };
    setLoader(true);
    service
      .docai_ingest_kdb(payload as IIngestKdbInput, project_main?.project_status)
      .then((res) => {
        // knowledgebase_summarization();
        const id = uuid();
        if (project_main?.project_status !== ProjectStatus.PRODUCTION) {
          auto_template()
        }
        setDontScroll(false);
        if (project_main?.project_status === ProjectStatus.PRODUCTION) {
          setUnique_kdbState(res.data.unique_kdb)
          setToSession(KB_NAMES_ENUM.UNIQUE_KDB, res.data.unique_kdb)
          docai_draft_keyinfo_ext(res.data.unique_kdb);
          setConversationList([
            {
              id,
              prompt: { value: "Hi", time: new Date() },
              answer: {
                value: "Hello! How may I assist you ?",
                time: new Date(),
              },
            },
          ])
        } else {
          top_querys_recommender();
          if (![ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded || conversationList.length == 0) {
            setConversationList([
              {
                id,
                prompt: { value: "Hi", time: new Date() },
                answer: {
                  value: "Hello! How may I assist you ?",
                  time: new Date(),
                },
              },
            ]);
          }
        }
        setLoader(false);
        const logData: ILogsModel = {
          log_id: uuid(),
          project_id: project_main?.project_id,
          username: user_id,
          solution: projectName || "",
          solution_type: projectType as ProjectTypeEnum,
          api: "/docai_ingest_kdb",
          prompt: "",
          result: "",
          tags: [],
          violations: [],
          role: "USER",
          time: new Date(),
        };
        pushToLog(logData);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  const top_querys_recommender = async () => {
    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
    const payload = {
      project_name: projectName,
      project_type: projectType,
      kdbName,
      version,
      project_id: project_main?.project_id,
    };
    service
      .docai_top_querys_recommender(payload as IKDBProjectInput, project_main?.project_status)
      .then((res) => {
        if (res?.data) {
          const questions_list = res?.data
            // ?.split(`• `)
            // ?.join("-")
            // ?.split("-")
            ?.filter((each: string) => each?.trim()?.length > 0);
          setQuestionsList(questions_list || []);
          const logData: ILogsModel = {
            log_id: uuid(),
            project_id: project_main?.project_id,
            username: user_id,
            solution: projectName || "",
            solution_type: projectType as ProjectTypeEnum,
            api: "/docai_top_querys_recommender",
            prompt: "",
            result: JSON.stringify(questions_list),
            tags: [],
            violations: [],
            role: "USER",
            time: new Date(),
          };
          pushToLog(logData);
        }
      })
      .catch((err) => console.log(err));
  };

  const docai_draft_keyinfo_ext = (unq_kdb: string, template?: string) => {
    modifyLoaders(LOADER_ENUM.EXTRACTED_DETAILS, LOADER_OPTIONS.ADD);
    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
    const payload = {
      // check for file exist
      // files: documentFile,
      files: ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded) ? undefined : documentFile,
      version,
      unique_kdb: project_main?.project_status === ProjectStatus.PRODUCTION ? unq_kdb : undefined,
      kdbName: [ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) ? kdbName : undefined,
      project_id: project_main?.project_id,
      project_name: projectName,
      file_name: (project_main?.project_status === ProjectStatus.PRODUCTION || ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded)) ? documentFile[0]?.path : undefined,
      ...([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) ? {
        project_name: projectName,
        project_type: projectType,
        template,
        reload: ([ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && isDockUploaded) ? "True" : "False",
      } : {})
    };
    service
      .docai_draft_keyinfo_ext(payload as IKeyInfoInput, project_main?.project_status)
      .then((res) => {
        const new_data =
          [ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) && template ?
            modifiedData(res?.data?.[template]) :
            res?.data?.map((each: any) => ({ ...each, dataId: uuid() }))
          ;
        setExtractedData(new_data);
        const logData: ILogsModel = {
          log_id: uuid(),
          project_id: project_main?.project_id,
          username: user_id,
          solution: projectName || "",
          solution_type: projectType as ProjectTypeEnum,
          api: "/docai_draft_keyinfo_ext",
          prompt: "",
          result: JSON.stringify(new_data),
          tags: [],
          violations: [],
          role: "USER",
          time: new Date(),
        };
        pushToLog(logData);
        modifyLoaders(LOADER_ENUM.EXTRACTED_DETAILS, LOADER_OPTIONS.REMOVE);
      })
      .catch((err) => {
        console.log(err);
        modifyLoaders(LOADER_ENUM.EXTRACTED_DETAILS, LOADER_OPTIONS.REMOVE);
      });
  };

  const docai_doc_validation = () => {
    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME)
    const unique_kdb = unique_kdbState
    const payload = {
      project_name: projectName,
      project_type: projectType,
      version,
      unique_kdb: project_main?.project_status === ProjectStatus.PRODUCTION ? unique_kdb : undefined,
      kdbName: [ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) ? kdbName : undefined,
      prompt: validationPrompt,
      project_id: project_main?.project_id,
    };
    service
      .docai_doc_validation(payload as IKDBProjectInput, project_main?.project_status)
      .then((res) => {
        res?.data && setDocType(res?.data);
        const logData: ILogsModel = {
          log_id: uuid(),
          project_id: project_main?.project_id,
          username: user_id,
          solution: projectName || "",
          solution_type: projectType as ProjectTypeEnum,
          api: "/docai_doc_validation",
          prompt: validationPrompt,
          result: res?.data || "",
          tags: [],
          violations: [],
          role: "USER",
          time: new Date(),
        };
        pushToLog(logData);
      })
      .catch((err) => console.log(err));
  };

  const knowledgebase_summarization = async () => {
    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME)
    const unique_kdb = unique_kdbState

    const payload = {
      project_name: projectName,
      project_type: projectType,
      unique_kdb: project_main?.project_status === ProjectStatus.PRODUCTION ? unique_kdb : undefined,
      kdbName: [ProjectStatus.DRAFT, ProjectStatus.WORK_SPACE].includes(project_main?.project_status as ProjectStatus) ? kdbName : undefined,
      version,
      prompt: summarizationPrompt,
      project_id: project_main?.project_id,
    };
    service
      .docai_kdb_summarization(payload as IKDBProjectInput, project_main?.project_status)
      .then((res) => {
        setDocSummary(res?.data || "");
        const logData: ILogsModel = {
          log_id: uuid(),
          project_id: project_main?.project_id,
          username: user_id,
          solution: projectName || "",
          solution_type: projectType as ProjectTypeEnum,
          api: "/docai_kdb_summarization",
          prompt: summarizationPrompt,
          result: res?.data || "",
          tags: [],
          violations: [],
          role: "USER",
          time: new Date(),
        };
        pushToLog(logData);
      })
      .catch((err) => console.log(err));
  };

  const gpt_vision = (prompt: string, id: any) => {
    const formData = new FormData();
    if ((fileType === 'image/jpeg') || (fileType === 'image/png')) {
      var blobed = new Blob(documentFile, { type: fileType });
      formData.append('files', blobed, 'image.png');
    }
    //  else {
    //   formData.append('files', croppedImageBlob, 'image.png');
    // }
    formData.append('query', prompt);
    // const id = uuid();
    console.log('Primary Id ')
    // console.log(id)
    if ((fileType === 'image/jpeg') || (fileType === 'image/png')) {
      service.gpt_vision(formData)
        .then(res => {
          setConversationList((prev) =>
            prev?.map((each) => {
              if (each?.id === id) {
                return {
                  ...each,
                  answer: {
                    value: res?.data?.analysis_result || "Something went wrong",
                    time: new Date(),
                  },
                };
              } else return each;
            })
          );
          setChatInitiate(true);
          setChatLoader(false);
        })
        .catch(err => console.log(err))
    }
  }

  const question_answer = async (prompt: string | any, init = false) => {
    let promptKey: any = 1
    promptKey = Object.keys(prompt)?.find(str => str?.includes('prompt'))
    setChatLoader(true);
    setDontScroll(false);
    const id = uuid();
    const new_conversation = init ? [] : conversationList;
    setConversationList([
      ...new_conversation,
      { id, prompt: { value: project_main?.project_status === ProjectStatus.PRODUCTION ? prompt[promptKey] : prompt, time: new Date() } },
    ]);

    //  { id, prompt: { value: (prompt as value), time: new Date() } },

    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
    const payload = {
      project_name: projectName,
      project_type: projectType,
      query: prompt,
      fileName: documentFile?.[0]?.path?.split(".")?.[0],
      kdbName,
      version,
      project_id: project_main?.project_id,
    };

    const unique_kdb = unique_kdbState
    const produtionPayload = {
      project_name: projectName,
      project_type: projectType,
      prompt: promptKey,
      prompt_query: prompt[promptKey],
      fileName: documentFile?.[0]?.path?.split(".")?.[0],
      unique_kdb: unique_kdb,
      version,
      project_id: project_main?.project_id,
    }
    // project_main?.project_status === ProjectStatus.PRODUCTION

    // remove query add prompt as key  --- 
    if (project_main?.project_status === ProjectStatus.PRODUCTION) {
      if ((fileType === 'image/jpeg') || (fileType === 'image/png')) {
        gpt_vision(prompt, id)
      }else{
        service
        .docai_get_userquery(produtionPayload as IDocUserQueryInput, project_main?.project_status)
        .then((res) => {
          setConversationList((prev) =>
            prev?.map((each) => {
              if (each?.id === id) {
                return {
                  ...each,
                  answer: {
                    value: res?.data || "Something went wrong",
                    time: new Date(),
                  },
                };
              } else return each;
            })
          );
          setChatInitiate(true)
          const logData: ILogsModel = {
            log_id: uuid(),
            project_id: project_main?.project_id,
            username: user_id,
            solution: projectName || "",
            solution_type: projectType as ProjectTypeEnum,
            api: "/docai_get_userquery",
            prompt,
            result: JSON.stringify(res?.data),
            tags: [],
            violations: [],
            role: "USER",
            time: new Date(),
          };
          console.log('chat test chat')
          save_chat_history(true, 'save_chat_hist');
          pushToLog(logData);
          setChatLoader(false);
        })
        .catch((err) => {
          console.log(err);
          setChatLoader(false);
        });
      }
    } else {
      if ((fileType === 'image/jpeg') || (fileType === 'image/png')) {
        gpt_vision(prompt, id)
      }else{
        service
        .docai_get_userquery(payload as IDocUserQueryInput, project_main?.project_status)
        .then((res) => {
          setConversationList((prev) =>
            prev?.map((each) => {
              if (each?.id === id) {
                return {
                  ...each,
                  answer: {
                    value: res?.data || "Something went wrong",
                    time: new Date(),
                  },
                };
              } else return each;
            })
          );
          setChatInitiate(true)
          const logData: ILogsModel = {
            log_id: uuid(),
            project_id: project_main?.project_id,
            username: user_id,
            solution: projectName || "",
            solution_type: projectType as ProjectTypeEnum,
            api: "/docai_get_userquery",
            prompt: project_main?.project_status === ProjectStatus.PRODUCTION ? prompt[promptKey] : prompt,
            result: JSON.stringify(res?.data),
            tags: [],
            violations: [],
            role: "USER",
            time: new Date(),
          };
          pushToLog(logData);
          setChatLoader(false);
        })
        .catch((err) => {
          console.log(err);
          setChatLoader(false);
        });
      }
    }
  };

  const docai_save_compliance_to_pg = (data: any, callBack: Function) => {
    const kdbName = getFromSession(KB_NAMES_ENUM.KDB_NAME);
    const payload = {
      project_name: projectName,
      project_type: projectType,
      kdbName,
      version,
      project_id: project_main?.project_id,
    };

    service
      .docai_save_compliance_to_pg(payload as IKDBProjectInput, data)
      .then((res) => {
        callBack(res?.data);
        // const logData: ILogsModel = {
        //   log_id: uuid(),
        //   project_id: project_main?.project_id,
        //   username: user_id,
        //   solution: projectName || "",
        //   solution_type: projectType as ProjectTypeEnum,
        //   api: "/docai_save_compliance_to_pg",
        //   prompt: "",
        //   result: res?.data,
        //   tags: [],
        //   violations: [],
        //   role: "USER",
        //   time: new Date(),
        // };
        // pushToLog(logData);
      })
      .catch((err) => console.log(err));
  };

  const tabProcess = () => {
    if (processingTabs === SOLUTION_STUDIO_TABS.VALIDATION) {
      return SOLUTION_STUDIO_TABS.VALIDATION;
    } else if (processingTabs === SOLUTION_STUDIO_TABS.SUMMARIZATION) {
      return SOLUTION_STUDIO_TABS.SUMMARIZATION;
    } else if (processingTabs === SOLUTION_STUDIO_TABS.TEMPLATE) {
      return SOLUTION_STUDIO_TABS.TEMPLATE;
    }
  }

  const [formValues, setFormValues] = useState<any>(
    {
      temparature: 0.1,
      chunk_overlap: 250,
      chunk_size: 250
    })

  const addConfig = (data: any) => {
    const finalData = { ...data, project_id: project_main?.project_id }
    service?.add_project_configuration(finalData).then((response: any) => {
      response?.data && toast.success(response?.data);
      // toggleSettingsModal()
    }).catch((error: any) => {
      console.log(error)
      toast.error('something went wrong')
    })
  }

  useEffect(() => {
    getConfig(project_main?.project_id)
  }, [project_main?.project_id])

  const getConfig = (projectId: string) => {
    const data = { project_id: projectId }
    service?.get_project_configuration_details(data).then((res: any) => {
      const resdata = {
        "chunk_overlap": res?.data?.chunk_overlap,
        "chunk_size": res?.data?.chunk_size,
        "model_name": res?.data?.model_name,
        "open_ai_key": res?.data?.open_ai_key,
        "temperature": res?.data?.temperature
      }
      setFormValues(resdata);
      console.log(resdata)
    }).catch((error: any) => {
      console.log(error)
    })
  }

  // Doc Ai content added updates are here
  const removeFile = (e: any) => {
    e?.stopPropagation();
    setAttributes([]);
    setInitAttributes([]);
    setIsDockUploaded(false)
  };

  const execute = () => {
    ingest_doc_db();
    auto_template()
  };

  const dataExtractionEnabled = useMemo(() => {
    if (project_main?.project_status === ProjectStatus.DRAFT) {
      return true
    } else {
      // console.log(promtStatus?.find((each: any) => each?.[APIS_LIST.DATA_EXTRACTION])?.status)
      return promtStatus?.find((each: any) => each?.[APIS_LIST.DATA_EXTRACTION])?.status
    }
  }, [project_main?.project_status, promtStatus])

  const handleAttribute = (value: ITemplateAttributesModel) => {
    setTempAttr(value);
    toggleAttrModal();
  };

  const downloadChat = () => {
    const element = document.createElement("a");
    const newData = conversationList?.map(
      (each) =>
        `User: ${each?.prompt?.value
          ?.trimStart()
          ?.trimEnd()}\nResponse: ${each?.answer?.value
            ?.trimStart()
            ?.trimEnd()}\n\n`
    );
    const file = new Blob(newData, { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "chat.txt";
    document.body.appendChild(element);
    element.click();
  };

  const summarization = {
    enableSummarization: true,
    knowledgebase_summarization: knowledgebase_summarization,
  };

  const singleView = () =><RawPdfViewer file={documentFile?.[0]} />
  return (
    <>
        <div className={`solition-studio ${themeName === ThemeTypes?.BLUE_THEME ? 'bright' :''}`}>
          {loader ? <GlobalLoader /> : <></>}
          <div className='left-menu'>
            <div className='header'>
              <img src={themeName === ThemeTypes?.BLUE_THEME ? ibexLightFullIcon : ibexDarkFullIcon} alt='Ibex' />
            </div>
            <div className='menu'>
              <div className='top-menu'>
                <Nav pills>
                  <div className='item home'>
                    <NavItem>
                      <NavLink
                        className={
                          processingTabs === SOLUTION_STUDIO_TABS.DASHBOARD
                            ? "active"
                            : ""
                        }
                        // onClick={() => setProcessingTabs(SOLUTION_STUDIO_TABS.DASHBOARD)}
                        onClick={() => navigate(`${RoutesEnum.LANDING}`)}
                      >
                        <img src={images[0]} alt="Home" /><div className='text'>Dashboard </div>
                      </NavLink>
                    </NavItem>
                  </div>
                  <div className='item'>
                    <NavItem>
                      <NavLink
                        className={
                          processingTabs === SOLUTION_STUDIO_TABS.DOCUMENT
                            ? "active"
                            : ""
                        }
                        onClick={() => setProcessingTabs(SOLUTION_STUDIO_TABS.DOCUMENT)}
                      >
                        <img src={processingTabs === SOLUTION_STUDIO_TABS.DOCUMENT ? checked[1] : images[1] } alt="Home" /><div className='text'>Document</div>
                      </NavLink>
                    </NavItem>
                  </div>
                  <div className='item'>
                    <NavItem>
                      <NavLink
                        className={
                          processingTabs === SOLUTION_STUDIO_TABS.VALIDATION
                            ? "active"
                            : ""
                        }
                        onClick={() => setProcessingTabs(SOLUTION_STUDIO_TABS.VALIDATION)}
                        disabled={!validationEnabled}
                      >
                        <img src={processingTabs === SOLUTION_STUDIO_TABS.VALIDATION ? checked[2] :images[2]} alt="Home" /><div className='text'>Validation</div>
                      </NavLink>
                    </NavItem>
                  </div>
                  <div className='item'>
                    <NavItem>
                      <NavLink
                        className={
                          processingTabs === SOLUTION_STUDIO_TABS.SUMMARIZATION
                            ? "active"
                            : ""
                        }
                        onClick={() => setProcessingTabs(SOLUTION_STUDIO_TABS.SUMMARIZATION)}
                        disabled={!summaryEnabled}
                      >
                        <img src={processingTabs === SOLUTION_STUDIO_TABS.SUMMARIZATION ? checked[3] :images[3]} alt="Home" /><div className='text'>Summarization</div>
                      </NavLink>
                    </NavItem>
                  </div>
                  <div className='item'>
                    <NavItem>
                      <NavLink
                        className={
                          processingTabs === SOLUTION_STUDIO_TABS.TEMPLATE
                            ? "active"
                            : ""
                        }
                        onClick={() => setProcessingTabs(SOLUTION_STUDIO_TABS.TEMPLATE)}
                      >
                        <img src={processingTabs === SOLUTION_STUDIO_TABS.TEMPLATE ? checked[4] :images[4]} alt="Home" /><div className='text'>Template</div>
                      </NavLink>
                    </NavItem>
                  </div>
                  <div className='item'>
                    <NavItem>
                      <NavLink
                        className={
                          processingTabs === SOLUTION_STUDIO_TABS.CHATBOT
                            ? "active"
                            : ""
                        }
                        onClick={() => setProcessingTabs(SOLUTION_STUDIO_TABS.CHATBOT)}
                      >
                        <img src={processingTabs === SOLUTION_STUDIO_TABS.CHATBOT ? checked[5] :images[5]} alt="Home" /><div className='text'>ChatAi</div>
                      </NavLink>
                    </NavItem>
                  </div>
                  {/* <div className='item'>
                    <NavItem>
                      <NavLink
                        className={
                          processingTabs === SOLUTION_STUDIO_TABS.CONFIGURE_PREFERENCES
                            ? "active"
                            : ""
                        }
                        onClick={() => setProcessingTabs(SOLUTION_STUDIO_TABS.CONFIGURE_PREFERENCES)}
                      >
                        <img src={processingTabs === SOLUTION_STUDIO_TABS.CONFIGURE_PREFERENCES ? checked[6] :images[9]} alt="Home" /><div className='text'>Configure&nbsp;Preferences</div>
                      </NavLink>
                    </NavItem>
                  </div> */}
                </Nav>
              </div>
              <div className='footer-menu'>
                <div className='item'><img src={images[6]} alt="Home" /><div className='text'>Help</div></div>
                <div className='item' onClick={() => toggleSettingsModal()}><img src={images[7]} alt="Home" /><div className='text'>Settings</div></div>
                <div className='item' onClick={() => logout()}><img src={images[8]} onClick={() => logout()} alt="Home" /><div className='text'>Logout</div></div>
                {/* <div className='item'><img className='iconImg' src={user} alt="Home" /><div className='text'>{userName}</div></div> */}
                <div className='item'>
                      {/* <img className='iconImg' src={user} alt="Home"/> */}
                      <Profile />
                    <div className='text'>{userName}</div></div>
                {/* <Profile /> */}
              </div>
            </div>
          </div>
          <div className='page-body'>
            <div className='project-header'>
              <div>{projectName}</div>
            </div>
            <TabContent activeTab={processingTabs}>
              <TabPane
                tabId={tabProcess()}
              // tabId={processingTabs === SOLUTION_STUDIO_TABS.VALIDATION ? SOLUTION_STUDIO_TABS.VALIDATION : (SOLUTION_STUDIO_TABS.SUMMARIZATION ? SOLUTION_STUDIO_TABS.SUMMARIZATION : SOLUTION_STUDIO_TABS.TEMPLATE )}
              >
                <div className='pane-content'>
                  <div className='child'>
                    <div className='document-validation'>
                      {/* <FileUploadContainers
                        files={documentFile}
                        handleFileChange={handleDocumentChange}
                        btnlabel={
                          <>
                            <img src={cloudUpload} /> Upload Document
                          </>
                        }
                        displayFilesContent={true}
                        displayInput={!documentFile || documentFile?.length < 1}
                        accept={{
                          "application/pdf": [".pdf"],
                          "image/jpeg": [".jpeg", ".jpg"],
                          "image/png": [".png"],
                        }}
                        maxFiles={
                          mode === DOC_AI_MODE_ENUM.SINGLE_DOCUMENT_MODE ? 1 : 20
                        }
                      /> */}
                      {documentFile ? (
                        singleView()
                      ) : (
                        <div className="not-found">No Document to display</div>
                      )}
                    </div>
                  </div>
                  <div className='child'>
                    {processingTabs === SOLUTION_STUDIO_TABS.VALIDATION ?
                      <div className='validation'>
                        <div className="label-box">
                          <Label for="validationPrompt">Validation Prompt</Label>
                        </div>
                        <Input
                          id="validationPrompt"
                          name="validationPrompt"
                          placeholder="Please enter a prompt for document validation"
                          type="textarea"
                          value={validationPrompt}
                          onChange={(e) => setValidationPrompt(e?.target?.value)}
                          disabled={project_main?.project_status === ProjectStatus.PRODUCTION}
                        />
                        <div className="btns">
                          <button
                            className='validation-options red'
                            onClick={() => setValidationPrompt("")}
                          >
                            <FontAwesomeIcon icon={faXmark} />
                            Clear
                          </button>
                          {/* {(project_main?.project_status === ProjectStatus.PRODUCTION || conversationList && conversationList?.length > 0) ? ( */}
                            <button
                              className='validation-options green'
                              disabled={
                                documentFile?.length < 1 ||
                                validationPrompt?.trim()?.length < 1
                              }
                              onClick={docai_doc_validation}
                            >
                              <FontAwesomeIcon icon={faCheck} /> Validate
                            </button>
                            {/* ) : <></>} */}
                        </div>
                        <br></br>
                        {docType ? <Alert>{docType}</Alert> : <></>}
                        <br></br>
                        <div className="production">
                          {project_main?.project_status?.toLocaleLowerCase() ===
                            "production" ? (
                            <Button className="to-prod-btn" onClick={toggleNewModal}>
                              CREATE VERSION
                            </Button>
                          ) : (
                            <Button className="to-prod-btn" onClick={toggleAPIModal}>
                              RELEASE TO PRODUCTION{" "}
                              <FontAwesomeIcon icon={faArrowRight} />
                            </Button>
                          )}
                        </div>

                      </div> : ""}

                    {processingTabs === SOLUTION_STUDIO_TABS.SUMMARIZATION ?
                      <div className='validation'>
                        <div className="label-box">
                          <Label for="validationPrompt">SUMMARY</Label>
                        </div>
                        <Input
                          id="validationPrompt"
                          name="validationPrompt"
                          placeholder="Add text to summarize"
                          type="textarea"
                          onChange={(e) => setSummarizationPrompt(e?.target?.value)}
                          disabled={project_main?.project_status === ProjectStatus.PRODUCTION}
                          value={summarizationPrompt}
                        />
                        <div className="btns">
                          <button
                            className='validation-options red'
                            onClick={() => setSummarizationPrompt("")}
                          >
                            <FontAwesomeIcon icon={faXmark} />
                            Clear
                          </button>
                          {/* {(project_main?.project_status === ProjectStatus.PRODUCTION || conversationList && conversationList?.length > 0) ? ( */}
                            <button
                              className='validation-options green'
                              disabled={
                                documentFile?.length < 1 ||
                                summarizationPrompt?.trim()?.length < 1
                              }
                              onClick={knowledgebase_summarization}
                            >
                              <FontAwesomeIcon icon={faFileInvoice} /> Summarizes
                            </button>
                            {/* ) : <></>} */}
                        </div>
                        <br></br>
                        {docSummary
                          ? docSummary && (project_main?.project_status === ProjectStatus.PRODUCTION || conversationList?.length > 0)
                            ? <div className='summary'>{docSummary}</div>
                            : "No data available"
                          : <div className='labeld'>Please click on Generate for summarization</div>}

                        <br></br>
                        <div className="production">
                          {project_main?.project_status?.toLocaleLowerCase() ===
                            "production" ? (
                            <Button className="to-prod-btn" onClick={toggleNewModal}>
                              CREATE VERSION
                            </Button>
                          ) : (
                            <Button className="to-prod-btn" onClick={toggleAPIModal}>
                              RELEASE TO PRODUCTION{" "}
                              <FontAwesomeIcon icon={faArrowRight} />
                            </Button>
                          )}
                        </div>

                      </div> : ""}

                    {processingTabs === SOLUTION_STUDIO_TABS.TEMPLATE ?
                      <div className='validation'>
                        <div className="label-box">
                          <Label for="validationPrompt">Extraxted Data</Label>
                          <div className='template-panel'>
                            {/* {initAttributes &&
                              initAttributes?.length > 0 &&
                              documentFile ? ( */}
                              {project_main?.project_status === ProjectStatus.DRAFT && 
                              <>
                               { LoaderHOC(

                                  <Button className="add-template" onClick={() => toggleAttrModal()}>
                                  <FontAwesomeIcon icon={faPlus} /> View Template
                                </Button>,
                                  LOADER_ENUM.ADD_TEMPLATE
                                )}
                                </>}
                             
                            {/* ) : <></>} */}
                          </div>
                        </div>
                        <div className="extracted-info">
                          {LoaderHOC(

                            <ExtractedData
                              extractedData={extractedData}
                              setExtractedData={setExtractedData}
                              saveCompliance={docai_save_compliance_to_pg}
                              project_main={project_main}
                            />,
                            LOADER_ENUM.EXTRACTED_DETAILS
                          )}
                        </div>
                        <div className="extracted-footer">
                          {project_main?.project_status?.toLocaleLowerCase() ===
                            "production" ? (
                            <Button onClick={toggleLogsModal} className="view-api">
                              VIEW LOG
                            </Button>
                          ) : (
                            <></>
                          )}
                          <div className="production">
                            {project_main?.project_status?.toLocaleLowerCase() ===
                              "production" ? (
                              <Button className="to-prod-btn" onClick={toggleNewModal}>
                                CREATE VERSION
                              </Button>
                            ) : (
                              <Button className="to-prod-btn" onClick={toggleAPIModal}>
                                RELEASE TO PRODUCTION{" "}
                                <FontAwesomeIcon icon={faArrowRight} />
                              </Button>
                            )}
                          </div>
                          {/* <Button onClick={()=>jsonToCsv(extractedData, projectName)}>
                            Download
                          </Button> */}
                        </div>

                      </div> : ""}
                  </div>
                </div>
              </TabPane>
              <TabPane tabId={SOLUTION_STUDIO_TABS.DOCUMENT}>
                <div className='pane-content'>
                  <div className='child child3'>
                    {documentFile!==undefined ?? <div className='header'>Document Viewer</div>}
                    <div className='document'>
                      <FileUploadContainers
                        files={documentFile}
                        handleFileChange={handleDocumentChange}
                        btnlabel={
                          <div className='labels'>
                            <img src={uploadInformation} alt="upload" /><div className='text'><u>Click to Upload</u><br></br>or
                              <br></br>drag and drop</div>
                          </div>
                        }
                        displayFilesContent={true}
                        displayInput={!documentFile || documentFile?.length < 1}
                        accept={{
                          "application/pdf": [".pdf"],
                          "image/jpeg": [".jpeg", ".jpg"],
                          "image/png": [".png"],
                        }}
                        maxFiles={
                          mode === DOC_AI_MODE_ENUM.SINGLE_DOCUMENT_MODE ? 1 : 20
                        }
                      />
                      {documentFile ? (
                        <>
                          {singleView()}
                        </>
                      ) : (
                        <div className="not-found">No Document to display</div>
                      )}
                    </div>
                  </div>
                </div>
              </TabPane>
              <TabPane tabId={SOLUTION_STUDIO_TABS.CHATBOT}>
                <div className='pane-content'>
                  <div className='child'>
                    <div className='document-validation'>
                      {documentFile ? (
                        singleView()
                      ) : (
                        <div className="not-found">No Document to display</div>
                      )}
                    </div>
                  </div>
                  <div className='child child2'>
                    <div className='chat-assist'>
                      <div className='chat-header'><div>iBex Chat Assistant</div>
                        <>{project_main?.project_status?.toLocaleLowerCase() === ProjectStatus.PRODUCTION ? (
                          <Button className="view-api" onClick={toggleAPIModal}>
                            VIEW APIs
                          </Button>
                        ) : (
                          <div><img src={DeleteIcon} alt="DeleteIcon" style={{cursor:'pointer'}} className="file-delete" onClick={()=>save_chat_history(false, 'clear_chat_history')                        }/>
                            <Button className="to-prod-btn" onClick={toggleAPIModal}>
                              PRODUCTION{" "}
                              <FontAwesomeIcon icon={faArrowRight} />
                            </Button>
                          </div>
                        )}</>
                      </div>
                      <ChatComponent2
                        conversationList={conversationList}
                        question_answer={question_answer}
                        questionsList={questionsList}
                        chatLoader={chatLoader}
                        isRecomendationsOptions={true}
                        isAddOptions={false}
                        displayCheck={true}
                        project_main={project_main}
                        textAreaDisable={
                          // !getFromSession(KB_NAMES_ENUM.KDB_NAME) ||
                          // conversationList?.length < 1 ||
                          project_main?.project_status?.toLocaleLowerCase() === ProjectStatus.PRODUCTION
                        }
                        setConversationList={setConversationList}
                        dontScroll={dontScroll}
                        setDontScroll={setDontScroll}
                      />
                    </div>
                    <br></br>
                    <div className="production">
                      {project_main?.project_status?.toLocaleLowerCase() ===
                        "production" ? (
                        <Button className="to-prod-btn" onClick={toggleNewModal}>
                          CREATE VERSION
                        </Button>
                      ) : (
                        <Button className="to-prod-btn" onClick={toggleAPIModal}>
                          RELEASE TO PRODUCTION{" "}
                          <FontAwesomeIcon icon={faArrowRight} />
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </TabPane>
              <TabPane tabId={SOLUTION_STUDIO_TABS.CONFIGURE_PREFERENCES}>
                <div className='pane-content'>
                  <div className='child child3'>
                    <Settings   
                      toggleSettingsModal={toggleSettingsModal}
                      formValues={formValues}
                      setFormValues={setFormValues}
                      addConfig={addConfig}
                    />
                  </div>
                </div>
              </TabPane>
            </TabContent>
          </div>
          <Modal
            className={`project-modal templateModal ${themeName === ThemeTypes?.BLUE_THEME ? '' : 'dark-modal'}`}
            isOpen={attrModal}
            fade={false}
            toggle={toggleAttrModal}
          >
            <ModalHeader toggle={toggleAttrModal}>Template Attributes</ModalHeader>
            <ModalBody>
              <TemplateAttributes
                attributes={attributes}
                setAttributes={setAttributes}
                resetAttributes={resetAttributes}
                submit_attributes={submit_attributes}
                tempAttr={tempAttr}
                setTempAttr={setTempAttr}
                handleCancel={toggleAttrModal}
              />
            </ModalBody>
          </Modal>


          {/* <Modal
            className={`project-modal templateModal settingsModal  ${themeName === ThemeTypes?.BLUE_THEME ? '' : 'dark-modal'}`}
            isOpen={settingsModal}
            fade={false}
            toggle={toggleSettingsModal}
          >
            <ModalHeader toggle={toggleSettingsModal}> Settings </ModalHeader>
            <ModalBody>
              <Settings
                toggleSettingsModal={toggleSettingsModal}
                formValues={formValues}
                setFormValues={setFormValues}
                addConfig={addConfig}
              />
            </ModalBody>
          </Modal> */}
          <ApiModal
            apiModal={apiModal}
            toggleAPIModal={toggleAPIModal}
            handleSuccess={handleAPIListSuccess}
            handleCancel={handleAPIListCancel}
            apisList={apisList}
            promptsList={promptsList}
            attributes={attributes}
            status={project_main?.project_status as ProjectStatus}
            promtStatus={promtStatus}
            selectedProject={project_main}
          />
          {displayLogsModal}

          <NewProjectModal
            selectedProject={project_main}
            projectModal={newModal}
            toggleProjectModal={toggleNewModal}
            apiSuccessCallback={apiSuccessCallback}
          />

        </div>
    </>
  )
}

export default Solutionstudio
